module.exports = __webpack_public_path__ + "static/media/playIcon.1ac68da2.svg";